import React, { useEffect, useRef, useState } from "react";
import "./styles.css";

// icons
import PlayeIcon from "../../icons/play.svg";
import PauseIcon from "../../icons/pause.svg";
import MutedIcon from "../../icons/muted.svg";
import UnMutedIcon from "../../icons/volume-up.svg";

function VideoPlayer({
  source,
  width,
  height,
  videoId,
  onDoubleClick = () => {
    console.log("No double click handler");
  },
}) {
  // state
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [muted, setMuted] = useState(false);
  // references
  const audioPlayer = useRef(); // reference our audio component
  const progressBar = useRef(); // reference our progress bar
  const animationRef = useRef(); // reference the animation

  useEffect(() => {
    var seconds = Math.floor(audioPlayer.current.duration);
    if (isNaN(seconds)) {
      seconds = 0;
    }
    setDuration(seconds);
  }, [audioPlayer?.current?.loadedmetadata, audioPlayer?.current?.readyState]);

  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const returnedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${returnedMinutes}:${returnedSeconds}`;
  };

  const togglePlayPause = () => {
    const prevValue = isPlaying;
    setIsPlaying(!prevValue);
    if (!prevValue) {
      audioPlayer.current.play();
      animationRef.current = requestAnimationFrame(whilePlaying);
    } else {
      audioPlayer.current.pause();
      cancelAnimationFrame(animationRef.current);
    }
  };

  const toggleVolume = () => {
    if (audioPlayer.current.muted) {
      audioPlayer.current.muted = false;
      setMuted(false);
    } else {
      audioPlayer.current.muted = true;
      setMuted(true);
    }
  };
  const whilePlaying = () => {
    progressBar.current.value = audioPlayer.current?.currentTime;
    changePlayerCurrentTime();
    animationRef.current = requestAnimationFrame(whilePlaying);
  };

  const changeRange = () => {
    audioPlayer.current.currentTime = progressBar.current.value;
    changePlayerCurrentTime();
  };

  const changePlayerCurrentTime = () => {
    setCurrentTime(progressBar.current.value);
  };

  const changleTimeByUser = (e) => {
    // var max = e.target.max;
    // var pos = e.pageX - e.target.offsetLeft;
    // var dual = Math.round(pos / max * 100);
    // alert(pos)
    // if (dual > duration) {
    //   dual = duration;
    // }
    progressBar.current.value = Number(progressBar.current.value + 10);
  };
  // const backThirty = () => {
  //   progressBar.current.value = Number(progressBar.current.value - 30);
  //   changeRange();
  // }

  // const forwardThirty = () => {
  //   progressBar.current.value = Number(progressBar.current.value + 30);
  //   changeRange();
  // }

  return (
    <>
      <figure className="video-container">
        <video
          src={source}
          style={{ width: "100%", height: height }}
          className="video"
          ref={audioPlayer}
          onEnded={() => {
            setIsPlaying(false);
          }}
          onClick={togglePlayPause}
          onDoubleClick={onDoubleClick}
        />
        <div className="controllers">
          <button onClick={togglePlayPause} className="icon">
            <img src={isPlaying ? PauseIcon : PlayeIcon} alt="Play or pause" />
          </button>
          <progress
            className="progressBar"
            ref={progressBar}
            min="0"
            max={duration}
            value="1"
            onChange={changeRange}
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              changleTimeByUser(e);
            }}
          />
          <div className="timer">{calculateTime(currentTime)}</div>
          <button className="icon" onClick={toggleVolume}>
            <img
              src={muted ? MutedIcon : UnMutedIcon}
              alt="mute or play"
              className={!muted && "mute"}
            />
          </button>
        </div>
      </figure>
    </>
  );
}

export default VideoPlayer;
